(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
  (() => {
    const kok = document.querySelector('[data-yazi]');
    if (!kok) return;
    const icerik = kok.querySelector('[data-icerik]');
    const nav = kok.querySelector('[data-icindekiler]');
    const liste = kok.querySelector('[data-icindekiler-liste]');
    const basliklar = [...icerik.querySelectorAll('h2')];
    const kimlik = (t) =>
      t
        .toLocaleLowerCase('tr-TR')
        .replace(/ç/g, 'c').replace(/ğ/g, 'g').replace(/ı/g, 'i').replace(/ö/g, 'o').replace(/ş/g, 's').replace(/ü/g, 'u')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '');

    /* İçindekiler: yazıdaki h2'lerden kurulur; iki başlıktan azsa gösterilmez */
    if (basliklar.length >= 2) {
      basliklar.forEach((h, i) => {
        if (!h.id) h.id = kimlik(h.textContent) || 'bolum-' + (i + 1);
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent;
        li.append(a);
        liste.append(li);
      });
      nav.hidden = false;
      const baglantilar = [...liste.querySelectorAll('a')];
      const gozcu = new IntersectionObserver(
        (girdiler) => {
          girdiler.forEach((g) => {
            if (!g.isIntersecting) return;
            baglantilar.forEach((a) => {
              if (a.hash === '#' + g.target.id) a.setAttribute('aria-current', 'true');
              else a.removeAttribute('aria-current');
            });
          });
        },
        { rootMargin: '0px 0px -70% 0px' }
      );
      basliklar.forEach((h) => gozcu.observe(h));
    }

    kok.querySelectorAll('[data-js-only]').forEach((e) => (e.hidden = false));
    const kopyala = kok.querySelector('[data-kopyala]');
    kopyala?.addEventListener('click', async () => {
      const durum = kok.querySelector('[data-kopyala-durum]');
      try {
        await navigator.clipboard.writeText(kopyala.dataset.kopyala);
        durum.textContent = kopyala.dataset.tamam || '';
        kopyala.textContent = kopyala.dataset.tamam || kopyala.textContent;
      } catch (_) {}
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    var dugme = document.querySelector('[data-cerez-tercih]');
    if (!dugme) return;
    var deneme = 0;
    // Shopify'ın bant betiği sayfadan sonra yüklenir; hazır olunca düğme görünür
    (function bekle() {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        dugme.hidden = false;
        dugme.addEventListener('click', function () {
          window.privacyBanner.showPreferences();
        });
      } else if (deneme++ < 20) {
        setTimeout(bekle, 500);
      }
    })();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const drawer = document.querySelector('[data-menu-drawer]');
    if (!drawer) return;
    const toggle = drawer.querySelector('summary');
    const close = () => {
      drawer.removeAttribute('open');
      toggle.focus();
    };
    drawer.querySelector('[data-menu-close]')?.addEventListener('click', close);
    drawer.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') close();
    });
    drawer.addEventListener('toggle', () => {
      document.documentElement.style.overflow = drawer.open ? 'hidden' : '';
      if (drawer.open) drawer.querySelector('[data-menu-close]')?.focus();
    });
    const acilirlar = document.querySelectorAll('[data-acilir]');
    const fare = window.matchMedia('(hover: hover) and (pointer: fine)');
    const kapat = (item) => {
      item.removeAttribute('data-acik');
      item.querySelector('.header__ac')?.setAttribute('aria-expanded', 'false');
    };
    acilirlar.forEach((item) => {
      const dugme = item.querySelector('.header__ac');
      let zaman;
      const ac = () => {
        clearTimeout(zaman);
        acilirlar.forEach((diger) => {
          if (diger !== item) kapat(diger);
        });
        item.setAttribute('data-acik', '');
        dugme.setAttribute('aria-expanded', 'true');
      };
      item.addEventListener('mouseenter', () => {
        if (fare.matches) ac();
      });
      item.addEventListener('mouseleave', () => {
        if (fare.matches) zaman = setTimeout(() => kapat(item), 160);
      });
      dugme.addEventListener('click', () => {
        /* Fareyle açılmış listeyi ok tıklaması kapatmasın */
        if (fare.matches && item.matches(':hover')) return ac();
        item.hasAttribute('data-acik') ? kapat(item) : ac();
      });
      item.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && item.hasAttribute('data-acik')) {
          kapat(item);
          dugme.focus();
        }
      });
      item.addEventListener('focusout', (event) => {
        if (!item.contains(event.relatedTarget)) kapat(item);
      });
      document.addEventListener('click', (event) => {
        if (!item.contains(event.target)) kapat(item);
      });
    });
    document.querySelectorAll('.header__dropdown').forEach((dropdown) => {
      dropdown.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          dropdown.removeAttribute('open');
          dropdown.querySelector('summary').focus();
        }
      });
      document.addEventListener('click', (event) => {
        if (!dropdown.contains(event.target)) dropdown.removeAttribute('open');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hediye-bulucu"]) return;
  try {
    
  if (!customElements.get('hediye-bulucu')) {
    const tl = (k) => Math.floor(k / 100).toLocaleString('tr-TR') + (k % 100 ? ',' + String(k % 100).padStart(2, '0') : '') + ' TL';
    const kac = (t) => String(t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
    const yer = (m, d) => m.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, a) => d[a] ?? '');

    customElements.define(
      'hediye-bulucu',
      class extends HTMLElement {
        connectedCallback() {
          this.veri = JSON.parse(this.querySelector('[data-veri]').textContent);
          this.M = this.veri.metin;
          const ilgi = new URLSearchParams(location.search).get('ilgi');
          this.durum = { kime: 'cocuk', sever: this.querySelector('[data-sever]')?.dataset.sever, butce: '0-0' };
          if (ilgi && this.querySelector(`[data-sever="${CSS.escape(ilgi)}"]`)) this.durum.sever = ilgi;
          ['kime', 'sever', 'butce'].forEach((ad) => {
            this.querySelectorAll(`[data-${ad}]`).forEach((b) =>
              b.addEventListener('change', () => {
                if (!b.checked) return;
                this.durum[ad] = b.dataset[ad];
                this.ciz();
              })
            );
          });
          this.querySelector('[data-butce-sifirla]').addEventListener('click', () => {
            this.durum.butce = '0-0';
            this.ciz();
          });
          this.ciz();
        }

        ciz() {
          const d = this.durum;
          ['kime', 'sever', 'butce'].forEach((ad) =>
            this.querySelectorAll(`[data-${ad}]`).forEach((b) => (b.checked = b.dataset[ad] === d[ad]))
          );
          const [min, max] = d.butce.split('-').map(Number);
          const uygun = (p) => p >= min && (!max || p <= max);

          const ciftler = this.veri.ciftler
            .filter((c) => (c.ga === d.sever || c.gb === d.sever) && uygun(c.p))
            .slice(0, 2)
            .map((c) => ({ ...c, cift: true }));
          const tekler = this.veri.urunler.filter((u) => u.g === d.sever && uygun(u.p));
          if (d.kime === 'kendim' || d.sever === 'oyuncu') tekler.sort((a, b) => b.p - a.p);
          const liste = [...tekler.slice(0, 6), ...ciftler].slice(0, 8);

          const secili = (ad) => {
            const r = this.querySelector(`[data-${ad}]:checked`);
            return r ? this.querySelector(`label[for="${r.id}"]`).textContent.trim() : '';
          };
          this.querySelector('[data-baslik]').textContent = this.M.kime[d.kime] || this.M.baslik;
          this.querySelector('[data-ozet]').textContent = [yer(this.M.oneri, { sayi: liste.length }), secili('sever'), secili('butce')].join(' · ');
          this.querySelector('[data-bos]').hidden = liste.length > 0;
          this.querySelector('[data-liste]').innerHTML = liste.map((u) => this.kart(u)).join('');
        }

        kart(u) {
          // Tek ürün: kategori sayfasındaki kartın aynısı (Liquid'de urun-kart ile üretildi)
          if (!u.cift) return u.html;
          // İki set: aynı kart düzeni, "+" görselin sağ üstünde (ana sayfadaki "Karşı karşıya" gibi)
          const ad = `${kac(u.a)} × ${kac(u.b)}`;
          return `<li class="urun-kart">
            <a class="urun-kart__baglanti" href="${u.url}">
              <span class="urun-kart__gorsel urun-kart__gorsel--cift">${u.img ? `<img src="${u.img}" alt="" loading="lazy">` : ''}${u.img2 ? `<img src="${u.img2}" alt="" loading="lazy">` : ''}</span>
              <div class="urun-kart__ust">
                <h3 class="urun-kart__ad">${ad}</h3>
                <span class="urun-kart__fiyat">${tl(u.p)} <s class="urun-kart__eski">${tl(u.eski)}</s></span>
              </div>
            </a>
            <button type="button" class="urun-kart__ekle" data-cift-ekle="${u.v}" data-set-ad="${ad}" aria-label="${ad}: ${kac(this.M.sepete_ekle)}">+</button>
            <span class="urun-kart__meta">${kac(this.M.iki_set)}</span>
          </li>`;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kitap-bulucu"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kitap-bulucu')) {
    const yer = (m, d) => m.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, a) => d[a] ?? '');
    const kac = (t) => String(t ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
    // Ana konular: "Temel kurallar" ve "Biyografi" eksik konu olarak önerilmez
    const ANA_KONU = ['Mat ve taktik', 'Oyunsonu', 'Strateji', 'Açılış', 'Partiler'];

    customElements.define(
      'kitap-bulucu',
      class extends HTMLElement {
        connectedCallback() {
          const veri = JSON.parse(this.querySelector('[data-veri]').textContent);
          /* Shopify çeviri metnindeki ' ve " işaretlerini &#39; ve &quot; olarak verir; metin JS ile yazılınca kod görünmesin diye çözülür */
          const cozucu = document.createElement('textarea');
          const coz = (d) =>
            typeof d === 'string'
              ? ((cozucu.innerHTML = d), cozucu.value)
              : Array.isArray(d)
                ? d.map(coz)
                : d && typeof d === 'object'
                  ? Object.fromEntries(Object.entries(d).map(([k, v]) => [k, coz(v)]))
                  : d;
          this.M = coz(veri.metin);
          this.K = new Map(veri.kitaplar.map((k, i) => [k.h, { ...k, i }]));
          this.P = new Map(veri.paketler.filter((p) => this.K.has(p.h)).map((p) => [p.h, p.ic.filter((h) => this.K.has(h))]));

          const q = new URLSearchParams(location.search);
          this.durum = {
            mod: q.has('bitti') ? 'bitti' : 'basla',
            // Seçenekler boş gelir; ziyaretçi neyi seçeceğini görsün. Adresle gelen seçim aynen açılır.
            ne: q.get('basamak') || null,
            konu: q.has('basamak') ? q.get('konu') || '' : null,
            bitti: new Set((q.get('bitti') || '').split(',').filter((h) => this.K.has(h))),
            // Telefonda sorular tek tek gelir; adresle gelen seçimde doğrudan sonuç açılır
            adim: q.has('basamak') ? 3 : 1,
            bittiSonuc: q.has('bitti'),
          };

          this.kitapListesi();
          this.querySelectorAll('[data-mod]').forEach((b) =>
            b.addEventListener('click', () => {
              this.durum.mod = b.dataset.mod;
              this.ciz();
            })
          );
          // "click": seçili seçeneğe yeniden dokunulduğunda da bir sonraki soruya geçilsin
          ['ne', 'konu'].forEach((ad) =>
            this.querySelectorAll(`[data-${ad}]`).forEach((r) =>
              r.addEventListener('click', () => {
                const d = this.durum;
                d[ad] = r.dataset[ad];
                const soru = +r.closest('[data-soru]').dataset.soru;
                if (this.mobil() && soru === d.adim) {
                  d.adim++;
                  this.ciz();
                  this.kaydir();
                } else this.ciz();
              })
            )
          );
          this.querySelector('[data-geri]').addEventListener('click', () => {
            this.durum.adim = Math.max(1, Math.min(this.durum.adim, 2) - 1);
            this.ciz();
          });
          this.querySelector('[data-degistir]').addEventListener('click', () => {
            if (this.durum.mod === 'basla') this.durum.adim = 1;
            else this.durum.bittiSonuc = false;
            this.ciz();
            this.kaydir();
          });
          this.querySelector('[data-sonuca]').addEventListener('click', () => {
            this.durum.bittiSonuc = true;
            this.ciz();
            this.kaydir();
          });
          this.querySelector('[data-temizle]').addEventListener('click', () => {
            this.durum.bitti.clear();
            this.ciz();
          });
          this.ciz();
        }

        // Bitirilen kitaplar: kapaklı ızgara, seviyeye göre gruplu; kapağı tanıyan dokunup işaretler
        kitapListesi() {
          // Setler (Kampı 1-4 gibi) listede yok: kitaplar tek tek işaretlenir, set içindekilerden anlaşılır
          const sira = [...this.K.values()]
            .filter((k) => !this.P.has(k.h))
            .sort((a, b) => (a.az ?? 9) - (b.az ?? 9) || (a.cok ?? 9) - (b.cok ?? 9) || a.t.localeCompare(b.t, 'tr'));
          const gruplar = [(k) => k.az != null && k.az <= 2, (k) => k.az === 3 || k.az === 4, (k) => k.az === 5, (k) => k.az == null];
          const oge = (k) => `<div class="kb__oge" data-ad="${kac(k.t.toLocaleLowerCase('tr'))}">
              <input class="visually-hidden" type="checkbox" id="kb-${kac(k.h)}" data-bitti="${kac(k.h)}">
              <label class="kb__kapak" for="kb-${kac(k.h)}">
                <span class="kb__kapak-resim${k.oran && Math.abs(k.oran - 1) > 0.05 ? ' kb__kapak-resim--dar' : ''}">${k.img ? `<img src="${k.img}" alt="" loading="lazy">` : ''}<span class="kb__tik" aria-hidden="true"></span></span>
                <span>${kac(k.t)}</span>
              </label>
            </div>`;
          const yer = this.querySelector('[data-kitaplar]');
          yer.innerHTML = gruplar
            .map((f, i) => {
              const liste = sira.filter(f);
              return liste.length ? `<div class="kb__grup" data-grup><h3>${kac(this.M.gruplar[i])}</h3><div class="kb__kapaklar">${liste.map(oge).join('')}</div></div>` : '';
            })
            .join('');
          yer.querySelectorAll('[data-bitti]').forEach((c) =>
            c.addEventListener('change', () => {
              this.durum.bitti[c.checked ? 'add' : 'delete'](c.dataset.bitti);
              this.ciz();
            })
          );
          // Ada göre süzme; boş kalan grup başlığı da gizlenir
          this.querySelector('[data-ara]').addEventListener('input', (e) => {
            const ara = e.target.value.trim().toLocaleLowerCase('tr');
            yer.querySelectorAll('.kb__oge').forEach((o) => (o.hidden = !o.dataset.ad.includes(ara)));
            yer.querySelectorAll('[data-grup]').forEach((g) => (g.hidden = !g.querySelector('.kb__oge:not([hidden])')));
            this.querySelector('[data-ara-yok]').hidden = !!yer.querySelector('.kb__oge:not([hidden])');
          });
        }

        mobil() {
          return matchMedia('(max-width: 749px)').matches;
        }

        kaydir() {
          if (this.mobil()) this.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }

        basamak(k) {
          if (k.az == null) return '';
          return k.az === k.cok ? yer(this.M.basamak, { n: k.az }) : yer(this.M.basamak_aralik, { a: k.az, b: k.cok });
        }

        // Kategori kartının aynısı; altına neden önerildiği yazılır
        kart(k, neden) {
          const alt = [neden, this.basamak(k), k.tur].filter(Boolean).map(kac).join(' · ');
          return k.html.replace(/<\/li>\s*$/, `<span class="kb__neden">${alt}</span></li>`);
        }

        blok(baslik, icerik) {
          return `<div class="kb__blok"><div class="bulucu__sonuc-ust"><h2>${kac(baslik)}</h2></div>${icerik}</div>`;
        }

        izgara(liste) {
          return `<ul class="liste__izgara" role="list">${liste.join('')}</ul>`;
        }

        ciz() {
          const d = this.durum;
          this.querySelectorAll('[data-mod]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.mod === d.mod)));
          this.querySelectorAll('[data-panel]').forEach((p) => (p.hidden = p.dataset.panel !== d.mod));
          ['ne', 'konu'].forEach((ad) => this.querySelectorAll(`[data-${ad}]`).forEach((r) => (r.checked = r.dataset[ad] === d[ad])));
          this.querySelectorAll('[data-bitti]').forEach((c) => (c.checked = d.bitti.has(c.dataset.bitti)));
          this.querySelector('[data-temizle]').hidden = d.bitti.size === 0;

          // Telefon görünümü: soru adımı, sonuç özeti ve alttaki "Önerileri gör" çubuğu
          const adim = Math.min(d.adim, 2);
          this.dataset.adim = adim;
          this.dataset.gorunum = d.mod === 'basla' ? (d.adim > 2 ? 'sonuc' : 'soru') : d.bittiSonuc && d.bitti.size ? 'sonuc' : 'liste';
          this.querySelector('[data-soru-no]').textContent = yer(this.M.soru_no, { n: adim });
          this.querySelector('[data-cizgi]').style.width = `${(adim / 2) * 100}%`;
          this.querySelector('[data-geri]').disabled = adim === 1;
          this.querySelector('[data-cubuk]').hidden = d.mod !== 'bitti' || d.bitti.size === 0;
          this.querySelector('[data-secili]').textContent = yer(this.M.secili, { sayi: d.bitti.size });
          const etiket = (ad) => {
            const r = this.querySelector(`[data-${ad}]:checked`);
            return r && r.value ? this.querySelector(`label[for="${r.id}"]`).textContent.trim() : '';
          };
          this.querySelector('[data-ozet]').textContent =
            d.mod === 'basla'
              ? [d.ne && yer(this.M.basamak, { n: d.ne }), etiket('konu')].filter(Boolean).join(' · ')
              : yer(this.M.bitti_ozet, { sayi: d.bitti.size });

          // Seçim adres çubuğunda kalır: standda QR ya da bağlantıyla paylaşılabilir
          const q = new URLSearchParams(location.search);
          ['bitti', 'kim', 'basamak', 'konu'].forEach((a) => q.delete(a));
          if (d.mod === 'bitti') {
            if (d.bitti.size) q.set('bitti', [...d.bitti].join(','));
          } else if (d.ne && (d.adim > 2 || !this.mobil())) {
            q.set('basamak', d.ne);
            if (d.konu) q.set('konu', d.konu);
          }
          history.replaceState(null, '', `${location.pathname}?${q}`.replace(/\?$/, ''));

          this.querySelector('[data-sonuc]').innerHTML = d.mod === 'bitti' ? this.bitirdiklerim() : this.baslangic();
        }

        // "Buradan başla": seçilen basamağı kapsayan kitaplar; tam o basamakta başlayan ve dar aralıklı olan önde.
        baslangic() {
          const d = this.durum;
          if (!d.ne) return `<p class="kb__bilgi">${kac(this.M.basla_bos)}</p>`;
          const b = +d.ne;
          const puan = (k) => {
            let p = (k.az === b ? 0 : 2) + (k.cok - k.az) * 0.5 + (this.P.has(k.h) ? 0.5 : 0);
            return p;
          };
          const uygun = [...this.K.values()].filter((k) => k.a && k.az != null && k.az <= b && b <= k.cok && (!d.konu || k.konu.includes(d.konu)));
          // Eşitlikte dizinin başındaki kitap öne geçer (Kampı 2, Kampı 3'ten önce)
          const sonra = new Set(uygun.map((k) => k.s));
          uygun.sort((x, y) => puan(x) + sonra.has(x.h) * 0.1 - (puan(y) + sonra.has(y.h) * 0.1) || x.i - y.i);
          if (!uygun.length) return `<p class="kb__bilgi">${kac(this.M.uygun_yok)}</p>`;

          const ana = uygun[0];
          const yol = [];
          for (let h = ana.s, adim = 0; h && adim < 6 && yol.length < 3; adim++) {
            const k = this.K.get(h);
            if (!k || k.h === ana.h || yol.includes(k)) break;
            if (k.a) yol.push(k);
            h = k.s;
          }
          const diger = uygun.slice(1).filter((k) => !yol.includes(k)).slice(0, 3);

          let html = this.blok(this.M.basla, `<ul class="liste__izgara kb__ana" role="list">${this.kart(ana, '')}</ul>`);
          if (yol.length) {
            const satir = (k) => {
              const img = k.html.match(/<img[^>]+src="([^"]+)"/);
              return `<li><a href="${kac(this.url(k))}">${img ? `<img src="${img[1]}" alt="" loading="lazy">` : ''}<span><b>${kac(k.t)}</b><small>${kac(this.basamak(k))}</small></span></a></li>`;
            };
            html += this.blok(this.M.sonra, `<ol class="kb__yol">${yol.map(satir).join('')}</ol>`);
          }
          if (diger.length) html += this.blok(this.M.diger, this.izgara(diger.map((k) => this.kart(k, ''))));
          return html;
        }

        url(k) {
          return k.html.match(/href="([^"]+)"/)?.[1] || '#';
        }

        // "Bitirdiklerimden öner": en ileri bitirilen kitabın sıradaki kitabı + hiç çalışılmamış konulardan en fazla iki kitap
        bitirdiklerim() {
          const bitti = new Set(this.durum.bitti);
          if (!bitti.size) return `<p class="kb__bilgi">${kac(this.M.bitti_bos)}</p>`;
          // Paket bitince içindekiler, içindekilerin hepsi bitince paket bitmiş sayılır
          this.P.forEach((ic, p) => {
            if (bitti.has(p)) ic.forEach((h) => bitti.add(h));
          });
          this.P.forEach((ic, p) => {
            if (ic.length && ic.every((h) => bitti.has(h))) bitti.add(p);
          });
          const aday = (h) => {
            const k = this.K.get(h);
            if (!k || !k.a || bitti.has(h) || k.az == null) return false;
            return !(this.P.get(h) || []).some((x) => bitti.has(x));
          };
          const biten = [...bitti].map((h) => this.K.get(h)).filter((k) => k && k.cok != null);
          // Yalnız basamaksız kitap (biyografi) seçildiyse seviye bilinmez, öneri yapılmaz
          if (!biten.length) return `<p class="kb__bilgi">${kac(this.M.bitti_bos)}</p>`;
          const ulasilan = Math.max(0, ...biten.map((k) => k.cok));
          const gorulen = new Set(biten.flatMap((k) => k.konu));

          let ana = null;
          let once = null;
          const sira = biten.filter((k) => !this.P.has(k.h)).sort((x, y) => y.cok - x.cok || y.az - x.az);
          for (const k of sira) {
            // Bitmiş kitapların üstünden atlayarak zincirde ilk bitmemiş kitaba gidilir; "sonrası" yazısı ondan hemen önceki kitabı gösterir
            let onceki = k;
            let h = k.s;
            for (let adim = 0; h && adim < 8 && !aday(h); adim++) {
              onceki = this.K.get(h) || onceki;
              h = this.K.get(h)?.s;
            }
            if (h && aday(h)) {
              ana = this.K.get(h);
              once = onceki;
              break;
            }
          }

          const zincir = new Set();
          for (let h = ana?.h, adim = 0; h && adim < 4; adim++) {
            zincir.add(h);
            h = this.K.get(h)?.s;
          }
          const eksik = [];
          ANA_KONU.forEach((konu) => {
            if (gorulen.has(konu) || eksik.length >= 2) return;
            const uy = [...this.K.values()]
              .filter((k) => aday(k.h) && k.konu.includes(konu) && k.az <= ulasilan + 1 && !zincir.has(k.h))
              .filter((k) => !(this.P.get(k.h) || []).some((x) => zincir.has(x)))
              .filter((k) => !eksik.some((e) => e.k === k))
              .sort((x, y) => Math.abs(x.az - ulasilan) - Math.abs(y.az - ulasilan) || this.P.has(x.h) - this.P.has(y.h) || x.i - y.i);
            if (uy.length) eksik.push({ k: uy[0], konu });
          });

          let html = '';
          html += this.blok(
            this.M.siradaki,
            ana
              ? `<ul class="liste__izgara kb__ana" role="list">${this.kart(ana, yer(this.M.neden_siradaki, { kitap: once.t }))}</ul>`
              : `<p class="kb__bilgi">${kac(this.M.hepsi_bitti)}</p>`
          );
          if (eksik.length) html += this.blok(this.M.eksik, this.izgara(eksik.map((e) => this.kart(e.k, yer(this.M.neden_konu, { konu: e.konu })))));
          return html;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koleksiyon"]) return;
  try {
    
  (() => {
    const panel = document.querySelector('[data-filtreler]');
    const ac = document.querySelector('[data-filtre-ac]');
    if (panel && ac) {
      const kapat = () => {
        panel.classList.remove('acik');
        ac.setAttribute('aria-expanded', 'false');
        document.documentElement.style.overflow = '';
        ac.focus();
      };
      ac.addEventListener('click', () => {
        panel.classList.add('acik');
        ac.setAttribute('aria-expanded', 'true');
        document.documentElement.style.overflow = 'hidden';
        panel.querySelector('[data-filtre-kapat]').focus();
      });
      panel.querySelector('[data-filtre-kapat]').addEventListener('click', kapat);
      /* Karartılmış alana dokununca panel kapanır */
      panel.addEventListener('click', (e) => {
        if (e.target === panel) kapat();
      });
      panel.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && panel.classList.contains('acik')) kapat();
      });
    }

    /* Masaüstünde bir filtre değişince liste hemen güncellenir; telefonda düğme seçime uyan ürün sayısını gösterir */
    const form = document.querySelector('[data-filtre-form]');
    if (form) {
      const gonder = form.querySelector('[data-filtre-gonder]');
      const masaustu = window.matchMedia('(min-width: 990px)');
      const adres = () => {
        const p = new URLSearchParams();
        new FormData(form).forEach((deger, ad) => {
          if (deger !== '') p.append(ad, deger);
        });
        return p;
      };
      let istek;
      const sayiyiGuncelle = async () => {
        if (istek) istek.abort();
        istek = new AbortController();
        const p = adres();
        p.set('section_id', panel.dataset.bolum);
        try {
          const yanit = await fetch(`${form.action}?${p}`, { signal: istek.signal });
          const html = await yanit.text();
          const sayi = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-urun-sayi]');
          if (sayi && gonder) gonder.textContent = gonder.dataset.sablon.replace('#', sayi.dataset.urunSayi);
        } catch (hata) {
          /* İptal edilen istek ya da ağ hatası: düğme eski sayıyla kalır */
        }
      };
      /* Boş fiyat kutuları adrese eklenmez */
      form.addEventListener('submit', () => {
        form.querySelectorAll('input[type="number"]').forEach((i) => {
          if (i.value === '') i.disabled = true;
        });
      });
      form.addEventListener('change', () => {
        if (masaustu.matches) form.requestSubmit();
        else sayiyiGuncelle();
      });
    }
    const siralama = document.querySelector('[data-siralama]');
    if (siralama) siralama.addEventListener('change', () => siralama.requestSubmit());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["one-cikanlar"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sekmeli]').forEach((kok) => {
    const sekmeler = [...kok.querySelectorAll('[role="tab"]')];
    const sec = (s) => {
      sekmeler.forEach((x) => {
        const secili = x === s;
        x.setAttribute('aria-selected', String(secili));
        x.tabIndex = secili ? 0 : -1;
        document.getElementById(x.getAttribute('aria-controls')).hidden = !secili;
      });
    };
    sekmeler.forEach((s, i) => {
      s.addEventListener('click', () => sec(s));
      s.addEventListener('keydown', (e) => {
        const yon = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!yon) return;
        const hedef = sekmeler[(i + yon + sekmeler.length) % sekmeler.length];
        sec(hedef);
        hedef.focus();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oyuncu-urun"]) return;
  try {
    
  if (!customElements.get('oyuncu-urun')) {
    customElements.define(
      'oyuncu-urun',
      class extends HTMLElement {
        connectedCallback() {
          this.querySelectorAll('[data-js-only]').forEach((e) => (e.hidden = false));
          this.kutu = this.querySelector('[data-adet-kutu]');

          this.querySelectorAll('[data-goster]').forEach((b) =>
            b.addEventListener('click', () => {
              this.querySelectorAll('[data-media]').forEach((m) => (m.hidden = m.dataset.media !== b.dataset.goster));
              this.querySelectorAll('[data-goster]').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
            })
          );

          this.querySelectorAll('[data-adet]').forEach((b) =>
            b.addEventListener('click', () => {
              this.kutu.value = Math.max(1, (+this.kutu.value || 1) + +b.dataset.adet);
              this.kutu.dispatchEvent(new Event('change'));
            })
          );
          this.kutu?.addEventListener('change', () => {
            const ust = +this.kutu.max || Infinity;
            this.kutu.value = Math.min(ust, Math.max(1, Math.floor(+this.kutu.value) || 1));
            this.ciz();
          });

          const form = this.querySelector('[data-form]');
          form.addEventListener('submit', async (e) => {
            e.preventDefault();
            const dugme = this.querySelector('[data-ekle]');
            if (dugme.getAttribute('aria-busy') === 'true') return;
            dugme.setAttribute('aria-busy', 'true');
            try {
              const yanit = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ items: [{ id: +form.querySelector('[name="id"]').value, quantity: +this.kutu.value || 1 }] }),
              });
              if (!yanit.ok) throw new Error();
              if (window.sepet) {
                await window.sepet.yenile();
                window.sepet.ac(dugme);
              } else location.href = '/cart';
            } catch (_) {
              location.href = '/cart';
            } finally {
              dugme.removeAttribute('aria-busy');
            }
          });
          this.ciz();
        }

        ciz() {
          const tl = (k) => Math.floor(k / 100).toLocaleString('tr-TR') + (k % 100 ? ',' + String(k % 100).padStart(2, '0') : '') + ' TL';
          const toplam = +this.dataset.fiyat * (+this.kutu?.value || 1);
          const yer = this.querySelector('[data-toplam]');
          if (yer) yer.textContent = tl(toplam);
          const esik = +this.dataset.esik;
          const yazi = this.querySelector('[data-kargo-yazi]');
          if (!esik || !yazi) return;
          const sepetle = toplam + +this.dataset.sepet;
          const kalan = esik - sepetle;
          yazi.textContent = '';
          const b = document.createElement('b');
          if (kalan > 0) {
            yazi.append(this.dataset.kargoOn + ' ');
            b.textContent = tl(kalan) + ' ' + this.dataset.kargoSon;
          } else {
            yazi.append(this.dataset.kargoTamamOn + ' ');
            b.textContent = this.dataset.kargoTamam;
          }
          yazi.append(b);
          this.querySelector('[data-kargo-dolu]').style.width = Math.min(100, Math.round((sepetle / esik) * 100)) + '%';
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ozel-urun"]) return;
  try {
    
  if (!customElements.get('ozel-urun')) {
    customElements.define(
      'ozel-urun',
      class extends HTMLElement {
        connectedCallback() {
          this.M = JSON.parse(this.querySelector('[data-metin]').textContent);
          this.form = this.querySelector('[data-form]');
          this.ad = this.querySelector('[data-ad]');
          this.onay = this.querySelector('[data-onay]');
          this.ekle = this.querySelector('[data-ekle]');
          this.querySelectorAll('[data-js-only]').forEach((e) => (e.hidden = false));

          this.querySelectorAll('[data-goster]').forEach((b) =>
            b.addEventListener('click', () => {
              this.querySelectorAll('[data-media]').forEach((m) => (m.hidden = m.dataset.media !== b.dataset.goster));
              this.querySelectorAll('[data-goster]').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
            })
          );

          this.querySelector('[data-kaydir]')?.addEventListener('click', (e) => {
            const hedef = this.querySelector('.atolye');
            if (!hedef) return;
            e.preventDefault();
            const yavas = matchMedia('(prefers-reduced-motion: reduce)').matches;
            hedef.scrollIntoView({ behavior: yavas ? 'auto' : 'smooth' });
            hedef.focus({ preventScroll: true });
          });

          this.querySelectorAll('[data-gorunum]').forEach((b) => b.addEventListener('click', () => this.gorunum(b.dataset.gorunum)));

          this.querySelectorAll('[data-es-renk]').forEach((n) => {
            const r = this.querySelector(`[data-renk="1"][value="${CSS.escape(n.dataset.esRenk)}"]`);
            if (r) n.style.background = r.dataset.hex;
          });
          this.querySelectorAll('[data-es1]').forEach((b) =>
            b.addEventListener('click', () => {
              this.renkSec(1, b.dataset.es1);
              this.renkSec(2, b.dataset.es2);
              this.onceki = b.dataset.es1;
              this.ciz();
            })
          );
          /* 1. renk, 2. renkle aynı seçilirse iki renk yer değiştirir */
          this.onceki = this.secili(1)?.value;
          this.querySelectorAll('[data-renk]').forEach((r) =>
            r.addEventListener('change', () => {
              if (r.dataset.renk === '1') {
                if (this.secili(2)?.value === r.value) this.renkSec(2, this.onceki);
                this.onceki = r.value;
              }
              this.ciz();
            })
          );

          this.querySelectorAll('[data-isim-sec]').forEach((r) =>
            r.addEventListener('change', () => {
              this.gorunum('kapali');
              this.ciz();
              if (r.value === '1') this.ad.focus();
            })
          );
          this.ad.addEventListener('input', () => {
            const temiz = this.ad.value.toLocaleUpperCase('tr-TR').replace(/[^A-ZÇĞİÖŞÜ0-9 .'&-]/g, '').slice(0, this.ad.maxLength);
            if (temiz !== this.ad.value) this.ad.value = temiz;
            this.onay.checked = false;
            this.gorunum('kapali');
            this.ciz();
          });
          this.onay.addEventListener('change', () => this.ciz());

          const hediye = this.querySelector('[data-hediye]');
          const not = this.querySelector('[data-not]');
          hediye.addEventListener('change', () => {
            not.disabled = !hediye.checked;
            if (hediye.checked) not.focus();
          });

          this.form.addEventListener('submit', (e) => {
            e.preventDefault();
            if (this.ekle.getAttribute('aria-disabled') === 'true') {
              (this.isimli() && !this.yazi() ? this.ad : this.onay).focus();
              return;
            }
            const veri = new FormData(this.form);
            const ozellik = {};
            for (const [k, v] of veri) {
              const m = k.match(/^properties\[(.+)\]$/);
              if (m && v) ozellik[m[1]] = v;
            }
            const items = [{ id: +veri.get('id'), quantity: 1, properties: ozellik }];
            if (this.isimli() && this.dataset.ucretId) {
              items.push({ id: +this.dataset.ucretId, quantity: 1, properties: { [this.M.isim_ozelligi]: this.yazi() } });
            }
            this.gonder(items, this.ekle);
          });

          this.querySelector('[data-hazir]')?.addEventListener('click', (e) => {
            const ilk = this.querySelector('[data-es1]');
            const r1 = ilk ? ilk.dataset.es1 : this.querySelector('[data-renk="1"]')?.value;
            const r2 = ilk ? ilk.dataset.es2 : this.querySelectorAll('[data-renk="2"]')[1]?.value;
            const ad1 = this.querySelector('[data-renk="1"]').name.slice(11, -1);
            const ad2 = this.querySelector('[data-renk="2"]').name.slice(11, -1);
            const sirt = this.querySelector('[data-sirt-varsayilan]');
            const ozellik = { [ad1]: r1, [ad2]: r2, [sirt.name.slice(11, -1)]: sirt.value };
            this.gonder([{ id: +this.form.querySelector('[name="id"]').value, quantity: 1, properties: ozellik }], e.currentTarget);
          });

          this.ciz();
        }

        secili(sira) {
          return this.querySelector(`[data-renk="${sira}"]:checked`);
        }

        renkSec(sira, deger) {
          this.querySelectorAll(`[data-renk="${sira}"]`).forEach((r) => {
            r.disabled = false;
            r.checked = r.value === deger;
          });
        }

        isimli() {
          return this.querySelector('[data-isim-sec]:checked')?.value === '1';
        }

        yazi() {
          return this.ad.value.trim();
        }

        gorunum(g) {
          this.querySelectorAll('[data-gorunum-yer]').forEach((y) => (y.hidden = y.dataset.gorunumYer !== g));
          this.querySelectorAll('[data-gorunum]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.gorunum === g)));
        }

        ciz() {
          const r1 = this.secili(1);
          let r2 = this.secili(2);
          this.querySelectorAll('[data-renk="2"]').forEach((r) => {
            const ayni = r1 && r.value === r1.value;
            r.disabled = ayni;
            r.nextElementSibling.title = ayni ? this.M.ayni_olamaz.replace('{{ renk }}', r.value) : r.value;
          });
          if (!r2 || r2.disabled) {
            const bos = this.querySelector('[data-renk="2"]:not(:disabled)');
            if (bos) bos.checked = true;
            r2 = this.secili(2);
          }

          const kutu = this.querySelector('[data-onizleme]');
          kutu.style.setProperty('--c1', r1.dataset.hex);
          kutu.style.setProperty('--c2', r2.dataset.hex);
          this.querySelector('[data-renk-ad="1"]').textContent = r1.value;
          this.querySelector('[data-renk-ad="2"]').textContent = r2.value;
          this.querySelectorAll('[data-es1]').forEach((b) =>
            b.setAttribute('aria-pressed', String(b.dataset.es1 === r1.value && b.dataset.es2 === r2.value))
          );

          const isimli = this.isimli();
          const yazi = this.yazi();
          this.querySelector('[data-isim-alan]').hidden = !isimli;
          this.ad.disabled = !isimli;
          this.querySelector('[data-sirt-varsayilan]').disabled = isimli;
          this.querySelector('[data-sayac]').textContent = `${this.ad.value.length} / ${this.ad.maxLength}`;

          const sirt = isimli && yazi ? yazi : this.dataset.varsayilan;
          const sirtYer = this.querySelector('[data-sirt]');
          sirtYer.textContent = sirt;
          sirtYer.dataset.boy = sirt.length > 11 ? 'kucuk' : sirt.length > 8 ? 'orta' : '';

          let etiket = this.M.onizleme.replace('{{ r1 }}', r1.value).replace('{{ r2 }}', r2.value);
          if (isimli && yazi) etiket += this.M.onizleme_isim.replace('{{ isim }}', yazi);
          this.querySelectorAll('[data-etiket]').forEach((e) => e.setAttribute('aria-label', etiket));

          this.querySelector('[data-ozet-renk]').textContent = `${r1.value} / ${r2.value}`;
          this.querySelector('[data-ozet-isim]').textContent = isimli && yazi ? yazi : this.M.isimsiz_ozet;

          this.querySelector('[data-onay-alan]').hidden = !isimli;
          const kapali = isimli && (!yazi || !this.onay.checked);
          this.ekle.setAttribute('aria-disabled', String(kapali));
          this.querySelector('[data-sepet-not]').textContent = isimli && !yazi ? this.M.not_isim_yok : kapali ? this.M.not_onay : this.M.not_hazir;

          const toplam = +this.dataset.fiyat + (isimli ? +this.dataset.ucret : 0);
          const tl = Math.floor(toplam / 100).toLocaleString('tr-TR') + (toplam % 100 ? ',' + String(toplam % 100).padStart(2, '0') : '') + ' TL';
          const yer = this.querySelector('[data-toplam]');
          if (yer) yer.textContent = tl;

          const kargoKutu = this.querySelector('[data-kargo]');
          if (kargoKutu) {
            const esik = +this.dataset.esik;
            const sepetle = +this.dataset.sepet + toplam;
            const kalan = esik - sepetle;
            const tutar = (k) => Math.floor(k / 100).toLocaleString('tr-TR') + (k % 100 ? ',' + String(k % 100).padStart(2, '0') : '') + ' TL';
            kargoKutu.querySelector('[data-kargo-yazi]').innerHTML = kalan > 0 ? this.M.kargo_kaldi.replace(/\{\{\s*tutar\s*\}\}/, `<b>${tutar(kalan)}</b>`) : this.M.kargo_tamam;
            kargoKutu.querySelector('[data-kargo-dolu]').style.width = Math.min(100, Math.round((sepetle / esik) * 100)) + '%';
          }
        }

        async gonder(items, dugme) {
          if (dugme.getAttribute('aria-busy') === 'true') return;
          dugme.setAttribute('aria-busy', 'true');
          try {
            const yanit = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items }),
            });
            if (!yanit.ok) throw new Error();
            if (window.sepet) {
              await window.sepet.yenile();
              window.sepet.ac(dugme);
            } else location.href = '/cart';
          } catch (_) {
            location.href = '/cart';
          } finally {
            dugme.removeAttribute('aria-busy');
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sahne"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sahneler]').forEach((kok) => {
    const yer = kok.querySelector('[data-kart-yeri]');
    const baslik = kok.querySelector('[data-sahne-baslik]');
    const ilkBaslik = baslik.textContent;
    const kartGoster = (id) => {
      const sablon = kok.querySelector(`template[data-kart="${id}"]`);
      if (!sablon) return;
      yer.replaceChildren(sablon.content.cloneNode(true));
      kok.querySelectorAll('[data-nokta]').forEach((n) => n.setAttribute('aria-pressed', String(n.dataset.nokta === id)));
    };
    kok.querySelectorAll('[data-nokta]').forEach((n) => {
      ['mouseenter', 'focus', 'click'].forEach((olay) => n.addEventListener(olay, () => kartGoster(n.dataset.nokta)));
    });
    const sahneSec = (i, b) => {
      kok.querySelectorAll('[data-sahne]').forEach((s) => (s.hidden = s.dataset.sahne !== String(i)));
      kok.querySelectorAll('[data-sahne-sec]').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
      baslik.textContent = (b && b.dataset.baslik) || ilkBaslik;
      const ilk = kok.querySelector(`[data-sahne="${i}"] [data-nokta]`);
      if (ilk) kartGoster(ilk.dataset.nokta);
    };
    kok.querySelectorAll('[data-sahne-sec]').forEach((b) => {
      ['mouseenter', 'focus', 'click'].forEach((olay) => b.addEventListener(olay, () => sahneSec(+b.dataset.sahneSec, b)));
    });
    const ilkNokta = kok.querySelector('[data-sahne="0"] [data-nokta]');
    if (ilkNokta) kartGoster(ilkNokta.dataset.nokta);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sepet-cekmece"]) return;
  try {
    
  if (!customElements.get('sepet-cekmece')) {
    customElements.define(
      'sepet-cekmece',
      class extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('[data-cekmece]');
          this.querySelector('[data-cekmece-kapat]').addEventListener('click', () => this.kapat());
          this.dialog.addEventListener('click', (e) => {
            if (e.target === this.dialog) this.kapat();
          });
          this.dialog.addEventListener('close', () => {
            document.documentElement.style.overflow = '';
            this.donulecek?.focus();
          });
          this.baglan(this);
          /* Sepet sayfasındaki düğmeler de ilk açılışta bağlansın (yalnız yenilemeden sonra değil) */
          const sayfa = document.querySelector('[data-sepet-sayfa]');
          if (sayfa) this.baglan(sayfa);

          /* Üst menüdeki sepet bağlantısı çekmeceyi açar (sepet sayfasındayken değil) */
          if (!location.pathname.endsWith('/cart')) {
            document.querySelectorAll('[data-sepet-ac]').forEach((a) =>
              a.addEventListener('click', (e) => {
                e.preventDefault();
                this.ac(a);
              })
            );
          }
          window.sepet = this;
          this.disaridanDinle();
        }

        /* Sepeti başka bir kod değiştirirse (uygulamalar, Clarity ajanı gibi) çekmece ve sayı da güncellensin.
           Sepete yazan her istekten sonra /cart.js'e bakılır; ekrandakiyle aynıysa bir şey yapılmaz. */
        disaridanDinle() {
          const sepetYazar = (url, yontem) =>
            /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(url)) && String(yontem || 'GET').toUpperCase() === 'POST';
          let zaman;
          const planla = () => {
            clearTimeout(zaman);
            zaman = setTimeout(() => this.yenileGerekirse(), 800);
          };
          const asilFetch = window.fetch.bind(window);
          window.fetch = (girdi, ayar) => {
            const istek = asilFetch(girdi, ayar);
            const url = girdi instanceof Request ? girdi.url : girdi;
            const yontem = ayar?.method || (girdi instanceof Request ? girdi.method : 'GET');
            if (sepetYazar(url, yontem)) istek.then(planla, planla);
            return istek;
          };
          const asilAc = XMLHttpRequest.prototype.open;
          XMLHttpRequest.prototype.open = function (yontem, url, ...geri) {
            if (sepetYazar(url, yontem)) this.addEventListener('loadend', planla);
            return asilAc.call(this, yontem, url, ...geri);
          };
          /* Geri tuşuyla dönülen sayfa önbellekten gelir; sekmeye dönülünce de sepet değişmiş olabilir */
          window.addEventListener('pageshow', (e) => e.persisted && this.yenileGerekirse());
          document.addEventListener('visibilitychange', () => document.visibilityState === 'visible' && this.yenileGerekirse());
        }

        async yenileGerekirse() {
          if (this.yenileniyor) return;
          try {
            const sepet = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
            const kutu = this.querySelector('[data-sepet-icerik]');
            if (String(sepet.item_count) !== kutu?.dataset.sayi || String(sepet.total_price) !== kutu?.dataset.toplam) await this.yenile();
          } catch (e) {}
        }

        ac(donulecek) {
          this.donulecek = donulecek || document.activeElement;
          document.documentElement.style.overflow = 'hidden';
          if (!this.dialog.open) this.dialog.showModal();
          this.yenileGerekirse();
        }

        kapat() {
          this.dialog.close();
        }

        /* Sepetin bölümlerini yeniden çizer: çekmece, sepet sayfası ve üst menüdeki sayı */
        async yenile(durum) {
          this.yenileniyor = true;
          try {
            await this.ciz(durum);
          } finally {
            this.yenileniyor = false;
          }
        }

        async ciz(durum) {
          const bolumler = [this.dataset.section];
          const sayfa = document.querySelector('[data-sepet-sayfa]');
          if (sayfa) bolumler.push(sayfa.dataset.sepetSayfa);
          const yanit = await fetch(`${location.pathname}?sections=${bolumler.join(',')}`);
          const html = await yanit.json();
          const yeni = new DOMParser().parseFromString(html[this.dataset.section], 'text/html');
          this.querySelector('[data-cekmece-govde]').innerHTML = yeni.querySelector('[data-cekmece-govde]').innerHTML;
          this.querySelector('[data-cekmece-sayi]').textContent = yeni.querySelector('[data-cekmece-sayi]').textContent;
          if (sayfa) {
            const s = new DOMParser().parseFromString(html[sayfa.dataset.sepetSayfa], 'text/html');
            sayfa.innerHTML = s.querySelector('[data-sepet-sayfa]').innerHTML;
            this.baglan(sayfa);
          }
          this.baglan(this);
          const sayi = this.querySelector('[data-sepet-icerik]')?.dataset.sayi || '0';
          document.querySelectorAll('[data-sepet-sayi]').forEach((el) => (el.textContent = sayi));
          document.querySelectorAll('[data-sepet-rozet]').forEach((el) => {
            el.textContent = sayi;
            el.hidden = sayi === '0';
          });
          if (durum) this.querySelector('[data-cekmece-durum]').textContent = durum;
        }

        async istek(url, govde) {
          const kutu = this.querySelector('[data-sepet-icerik]');
          kutu?.setAttribute('aria-busy', 'true');
          try {
            const yanit = await fetch(url, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify(govde),
            });
            const sonuc = await yanit.json();
            if (!yanit.ok || sonuc.status) throw new Error(sonuc.description || sonuc.message);
            return sonuc;
          } finally {
            kutu?.removeAttribute('aria-busy');
          }
        }

        baglan(kok) {
          kok.querySelectorAll('[data-sepet-icerik] [data-degistir]').forEach((a) => {
            if (a.dataset.bagli) return;
            a.dataset.bagli = '1';
            a.addEventListener('click', async (e) => {
              e.preventDefault();
              const satir = a.closest('[data-satir]');
              await this.istek('/cart/change.js', { line: +satir.dataset.satir, quantity: +a.dataset.degistir });
              await this.yenile();
            });
          });

          kok.querySelectorAll('[data-rakip-ekle]').forEach((b) => {
            if (b.dataset.bagli) return;
            b.dataset.bagli = '1';
            b.addEventListener('click', async () => {
              const setId = 'set-' + Date.now().toString(36);
              const ozellik = { Set: b.dataset.setAd, _set_id: setId };
              b.setAttribute('aria-busy', 'true');
              await this.istek('/cart/change.js', { id: b.dataset.satirAnahtar, properties: ozellik });
              await this.istek('/cart/add.js', { items: [{ id: +b.dataset.rakipEkle, quantity: 1, properties: ozellik }] });
              await this.yenile();
            });
          });

          const hediye = kok.querySelector('[data-sepet-hediye]');
          const not = kok.querySelector('[data-sepet-not]');
          if (hediye && !hediye.dataset.bagli) {
            hediye.dataset.bagli = '1';
            hediye.addEventListener('change', () =>
              this.istek('/cart/update.js', { attributes: { 'Hediye kartı': hediye.checked ? 'Evet' : '' }, note: hediye.checked ? not.value : '' })
            );
            let zaman;
            not.addEventListener('input', () => {
              clearTimeout(zaman);
              zaman = setTimeout(() => this.istek('/cart/update.js', { note: not.value }), 600);
            });
          }
        }
      }
    );

    /* Kartlardaki "+" (data-hizli-ekle) ve iki set düğmeleri (data-cift-ekle) sepete ekler ve çekmeceyi açar.
       Bu bölüm her sayfada olduğu için ekleme kodu burada durur. */
    document.addEventListener('click', async (e) => {
      const dugme = e.target.closest('[data-hizli-ekle], [data-cift-ekle]');
      if (!dugme || dugme.getAttribute('aria-busy') === 'true') return;
      dugme.setAttribute('aria-busy', 'true');
      let items;
      if (dugme.dataset.ciftEkle) {
        const ozellik = { Set: dugme.dataset.setAd, _set_id: 'set-' + Date.now().toString(36) };
        // Takımını Kur'da tek varyantlı sete seçilen renk, o setin satırına "Renk" notu olarak yazılır
        const renkler = (dugme.dataset.renkler || '').split('|');
        items = dugme.dataset.ciftEkle.split(',').map((id, i) => ({
          id: +id,
          quantity: 1,
          properties: renkler[i] ? { ...ozellik, Renk: renkler[i] } : ozellik,
        }));
      } else {
        items = [{ id: +dugme.dataset.hizliEkle, quantity: 1 }];
      }
      try {
        const yanit = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (!yanit.ok) throw new Error();
        if (window.sepet) {
          await window.sepet.yenile();
          window.sepet.ac(dugme);
        } else location.href = '/cart';
      } catch (_) {
        location.href = '/cart';
      } finally {
        dugme.removeAttribute('aria-busy');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["set-urun"]) return;
  try {
    
  if (!customElements.get('set-urun')) {
    const tl = (kurus) => {
      const lira = Math.floor(kurus / 100);
      const k = kurus % 100;
      return lira.toLocaleString('tr-TR') + (k ? ',' + String(k).padStart(2, '0') : '') + ' TL';
    };
    const yerlestir = (metin, degerler) => metin.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, a) => degerler[a] ?? '');

    customElements.define(
      'set-urun',
      class extends HTMLElement {
        connectedCallback() {
          if (this.hazir) return;
          this.hazir = true;
          this.veri = JSON.parse(this.querySelector('[data-veri]').textContent);
          this.M = this.veri.metin;
          this.form = this.querySelector('[data-form]');

          this.querySelectorAll('[data-goster]').forEach((b) => b.addEventListener('click', () => this.gorsel(b.dataset.goster)));
          this.querySelectorAll('[data-secim]').forEach((r) => r.addEventListener('change', () => this.varyantDegisti()));
          this.querySelectorAll('[data-renk]').forEach((r) => r.addEventListener('change', () => this.renkDegisti()));
          this.form.addEventListener('submit', (e) => this.gonder(e));
          /* Hediye kartı sepetin kendisine yazılır (çekmecedeki seçenekle aynı): ürün eklenmeden önce ya da sonra işaretlenebilir */
          const hediye = this.querySelector('[data-hediye]');
          const not = this.querySelector('[data-not]');
          const sepeteYaz = (govde) =>
            fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(govde) });
          hediye.addEventListener('change', () =>
            sepeteYaz({ attributes: { 'Hediye kartı': hediye.checked ? 'Evet' : '' }, note: hediye.checked ? not.value : '' })
          );
          let notZaman;
          not.addEventListener('input', () => {
            clearTimeout(notZaman);
            notZaman = setTimeout(() => sepeteYaz({ note: not.value }), 600);
          });

          this.varyantDegisti(true);
          if (document.readyState === 'complete') this.renkleriOnYukle();
          else window.addEventListener('load', () => this.renkleriOnYukle(), { once: true });
        }

        renkUrl(ek, w) {
          return this.veri.renk_sablon.replace('-siyah.webp', `-${ek}.webp`).replace('width=1400', 'width=' + w);
        }

        /* Sayfa yüklendikten sonra boşta kalınca her rengin küçük görseli (400px, ~26 KB) indirilir;
           renge basınca görsel beklemeden çıkar. Veri tasarrufu açıksa ya da bağlantı çok yavaşsa yapılmaz. */
        renkleriOnYukle() {
          if (!this.veri.renk_sablon) return;
          const b = navigator.connection;
          if (b && (b.saveData || /2g/.test(b.effectiveType || ''))) return;
          const ekler = new Set();
          this.querySelectorAll('[data-renk]').forEach((r) => r.dataset.renk && ekler.add(r.dataset.renk));
          this.veri.kendi.varyantlar.forEach((v) => v.r && !v.m && ekler.add(v.r));
          const indir = () => ekler.forEach((ek) => (new Image().src = this.renkUrl(ek, 400)));
          if ('requestIdleCallback' in window) requestIdleCallback(indir, { timeout: 3000 });
          else setTimeout(indir, 1500);
        }

        get varyant() {
          const id = +this.querySelector('[data-varyant-id]').value;
          return this.veri.kendi.varyantlar.find((v) => v.id === id) || this.veri.kendi.varyantlar[0];
        }

        gorsel(id) {
          if (!id || id === '0') return;
          const hedef = this.querySelector(`[data-media="${id}"]`);
          if (!hedef) return;
          this.renkSira = (this.renkSira || 0) + 1;
          this.querySelectorAll('[data-media]').forEach((el) => (el.hidden = el !== hedef));
          const renk = this.querySelector('[data-renk-resim]');
          if (renk) renk.hidden = true;
          this.querySelectorAll('[data-goster]').forEach((b) => b.setAttribute('aria-pressed', b.dataset.goster === String(id)));
        }

        /* Boyanmış set görseli. Eski görsel, yenisi yüklenene kadar yerinde kalır (boş ekran yok):
           önce önceden indirilmiş küçük boy gösterilir, tam boy (srcset) gelince netleşir. */
        renkGorseli(ek, ad) {
          const kutu = this.querySelector('[data-renk-resim]');
          if (!kutu || !this.veri.renk_sablon) return;
          const img = kutu.querySelector('img');
          const sira = (this.renkSira = (this.renkSira || 0) + 1);
          const goster = () => {
            this.querySelectorAll('[data-media]').forEach((el) => (el.hidden = true));
            kutu.hidden = false;
            this.querySelectorAll('[data-goster]').forEach((b) => b.setAttribute('aria-pressed', 'false'));
          };
          let tamGeldi = false;
          const kucuk = new Image();
          kucuk.onload = () => {
            if (sira !== this.renkSira || tamGeldi) return;
            img.removeAttribute('srcset');
            img.src = kucuk.src;
            img.alt = ad || '';
            goster();
          };
          kucuk.src = this.renkUrl(ek, 400);
          const srcset = [600, 900, 1200, 1400].map((w) => `${this.renkUrl(ek, w)} ${w}w`).join(', ');
          const tam = new Image();
          const degistir = () => {
            if (sira !== this.renkSira) return;
            tamGeldi = true;
            img.srcset = srcset;
            img.src = this.renkUrl(ek, 1400);
            img.alt = ad || '';
            goster();
          };
          tam.onload = tam.onerror = degistir;
          tam.sizes = img.sizes;
          tam.srcset = srcset;
          tam.src = this.renkUrl(ek, 1400);
        }

        /* Tek varyantlı set: seçilen renk satır notu olur, görsel o renge döner; "fotoğraftaki" ilk görsele döner */
        renkDegisti() {
          const r = this.querySelector('[data-renk]:checked');
          if (!r) return;
          const ad = this.querySelector('[data-renk-ad]');
          if (ad) ad.textContent = r.value;
          if (r.dataset.renk) this.renkGorseli(r.dataset.renk, r.value);
          else this.gorsel(String(this.veri.ilk_media));
        }

        varyantDegisti(ilk) {
          const secimler = [];
          this.querySelectorAll('[data-secim]:checked').forEach((r) => (secimler[+r.dataset.secim] = r.value));
          let v = this.varyant;
          if (secimler.length) {
            v = this.veri.kendi.varyantlar.find((x) => x.o.every((d, i) => secimler[i] === undefined || d === secimler[i])) || v;
            this.querySelector('[data-varyant-id]').value = v.id;
            secimler.forEach((d, i) => {
              const yer = this.querySelector(`[data-secim-deger="${i}"]`);
              if (yer) yer.textContent = d;
            });
            // Sayfa ilk açılışta asıl fotoğrafla gelir; bağlantıda renk seçiliyse o rengin görseli gösterilir
            const linkte = new URLSearchParams(location.search).has('variant');
            if (v.r && !v.m && (!ilk || linkte)) this.renkGorseli(v.r, v.o[0]);
            if (!ilk) {
              if (v.m) this.gorsel(String(v.m));
              const url = new URL(location.href);
              url.searchParams.set('variant', v.id);
              history.replaceState(null, '', url);
            }
          }
          this.guncelle();
        }

        guncelle() {
          const v = this.varyant;
          this.querySelector('[data-fiyat]').textContent = tl(v.p);
          const eski = this.querySelector('[data-eski]');
          eski.hidden = !(v.c > v.p);
          if (v.c > v.p) eski.textContent = tl(v.c);
          const ekle = this.querySelector('[data-ekle]');
          ekle.disabled = !v.a;
          this.querySelector('[data-ekle-yazi]').textContent = v.a ? this.M.sepete_ekle + ' · ' + tl(v.p) : this.M.tukendi;
          this.kargo(v.p);
        }

        kargo(tutar) {
          const kutu = this.querySelector('[data-kargo]');
          if (!kutu) return;
          const esik = +this.dataset.esik;
          const toplam = +this.dataset.sepet + tutar;
          const kalan = esik - toplam;
          kutu.querySelector('[data-kargo-yazi]').innerHTML = kalan > 0 ? yerlestir(this.M.kargo_kaldi, { tutar: `<b>${tl(kalan)}</b>` }) : this.M.kargo_tamam;
          kutu.querySelector('[data-kargo-dolu]').style.width = Math.min(100, Math.round((toplam / esik) * 100)) + '%';
        }

        async gonder(e) {
          /* Sepet çekmecesi yoksa (ya da JS kapalıysa) normal form gönderimiyle eklenir */
          if (!window.sepet) return;
          e.preventDefault();
          if (this.mesgul) return;
          const hediye = {};
          new FormData(this.form).forEach((deger, ad) => {
            const m = ad.match(/^properties\[(.+)\]$/);
            if (m && deger) hediye[m[1]] = deger;
          });
          const items = [{ id: this.varyant.id, quantity: 1, properties: hediye }];
          this.mesgul = true;
          const ekle = this.querySelector('[data-ekle]');
          ekle.setAttribute('aria-busy', 'true');
          const hata = this.querySelector('[data-hata]');
          hata.hidden = true;
          try {
            const yanit = await fetch(this.dataset.ekleUrl + '.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items }),
            });
            const sonuc = await yanit.json();
            if (!yanit.ok || sonuc.status) throw new Error(sonuc.description || this.M.hata);
            await window.sepet.yenile(this.M.eklendi);
            window.sepet.ac(ekle);
          } catch (err) {
            hata.textContent = err.message || this.M.hata;
            hata.hidden = false;
          } finally {
            this.mesgul = false;
            ekle.removeAttribute('aria-busy');
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sss-sayfa"]) return;
  try {
    
  if (!customElements.get('sss-sayfa')) {
    customElements.define(
      'sss-sayfa',
      class extends HTMLElement {
        connectedCallback() {
          this.querySelectorAll('[data-js-only]').forEach((e) => (e.hidden = false));
          this.sorular = [...this.querySelectorAll('[data-soru]')];
          this.konu = '';
          this.querySelectorAll('[data-say]').forEach((s) => {
            s.textContent = s.dataset.say ? this.sorular.filter((q) => q.dataset.konu === s.dataset.say).length : this.sorular.length;
          });
          this.querySelectorAll('[data-konu-sec]').forEach((b) =>
            b.addEventListener('click', () => {
              this.konu = b.dataset.konuSec;
              this.querySelectorAll('[data-konu-sec]').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
              this.suz();
            })
          );
          this.ara = this.querySelector('[data-ara]');
          this.ara.addEventListener('input', () => this.suz());
          const q = new URLSearchParams(location.search).get('q');
          if (q) {
            this.ara.value = q;
            this.suz();
          }
        }

        suz() {
          const kucuk = (t) => (t || '').toLocaleLowerCase('tr-TR');
          const aranan = kucuk(this.ara.value.trim());
          let say = 0;
          this.sorular.forEach((s) => {
            const uygun = (!this.konu || s.dataset.konu === this.konu) && (!aranan || kucuk(s.textContent).includes(aranan));
            s.hidden = !uygun;
            if (uygun) say++;
            if (uygun && aranan) s.open = true;
          });
          this.querySelector('[data-bos]').hidden = say > 0;
          this.querySelector('[data-sonuc]').textContent = aranan || this.konu ? `${say} / ${this.sorular.length}` : '';
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["takim-kur"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('takim-kur')) {
    customElements.define(
      'takim-kur',
      class extends HTMLElement {
        connectedCallback() {
          this.veri = JSON.parse(this.querySelector('[data-veri]').textContent);
          this.M = this.veri.metin;
          this.indirim = +this.dataset.indirim || 0;
          this.taraf = 1;
          this.grup = '';
          this.secim = { 1: null, 2: null };
          const p = new URLSearchParams(location.search);
          const bul = (k) => this.veri.setler.find((s) => s.k === k && s.a);
          if (bul(p.get('a'))) this.secim[1] = { s: bul(p.get('a')), v: bul(p.get('a')).v };
          if (bul(p.get('b'))) this.secim[2] = { s: bul(p.get('b')), v: bul(p.get('b')).v };
          if (this.secim[1] && !this.secim[2]) this.taraf = 2;

          this.querySelectorAll('[data-sekme]').forEach((b) => b.addEventListener('click', () => this.sekme(+b.dataset.sekme)));
          this.querySelectorAll('[data-serit]').forEach((b) =>
            b.addEventListener('click', () => {
              this.sekme(+b.dataset.serit);
              this.querySelector('.kur__secici').scrollIntoView({ behavior: 'smooth', block: 'start' });
            })
          );
          this.querySelectorAll('[data-grup]').forEach((b) =>
            b.addEventListener('click', () => {
              this.grup = b.dataset.grup;
              this.querySelectorAll('[data-grup]').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
              this.liste();
            })
          );
          this.querySelectorAll('[data-renk-sec]').forEach((sel, i) => {
            ['pointerdown', 'focus'].forEach((o) => sel.addEventListener(o, () => this.renkleriOnYukle(this.secim[i + 1])));
            sel.addEventListener('change', () => {
              const sec = this.secim[i + 1];
              // Çok renkli sette renk bir varyanttır; tek varyantlı sette sipariş satırına "Renk" notu olur
              if (sec.s.vs.length > 1) sec.v = +sel.value;
              else sec.c = sel.value;
              this.ciz();
            });
          });
          this.querySelector('[data-gor]').addEventListener('click', () =>
            this.querySelector('.kur__sahne').scrollIntoView({ behavior: 'smooth', block: 'start' })
          );
          this.sahneGorunur = true;
          new IntersectionObserver(([e]) => {
            this.sahneGorunur = e.isIntersecting;
            this.gorDugme();
          }).observe(this.querySelector('.kur__sahne'));
          this.sekme(this.taraf);
          this.ciz();
        }

        /* "Takımını gör": iki set seçiliyken ve önizleme ekranda değilken görünür */
        gorDugme() {
          const a = this.varyant(this.secim[1]);
          const b = this.varyant(this.secim[2]);
          const d = this.querySelector('[data-gor]');
          d.hidden = !(a && b) || this.sahneGorunur;
          if (a && b) d.querySelector('[data-gor-yazi]').textContent = `${this.M.gor} · ${this.para(Math.max(0, a.p + b.p - this.indirim))}`;
        }

        para(kurus) {
          const lira = Math.round(kurus / 100);
          return lira.toLocaleString('tr-TR') + ' TL';
        }

        kacis(t) {
          return String(t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
        }

        sekme(n) {
          this.taraf = n;
          this.querySelectorAll('[data-sekme]').forEach((b) => b.setAttribute('aria-selected', String(+b.dataset.sekme === n)));
          this.querySelectorAll('[data-serit]').forEach((b) => b.toggleAttribute('data-aktif', +b.dataset.serit === n));
          this.ipucu();
          this.liste();
          this.oneri();
        }

        /* Sekmenin altında sıradaki adımı söyler; sekme adında seçilen set görünür */
        ipucu() {
          const a = this.secim[1];
          const b = this.secim[2];
          let metin = this.M.ipucu_1;
          if (a && b) metin = this.M.ipucu_hazir;
          else if (this.taraf === 2 && a) metin = this.M.ipucu_2.replace(/\{\{\s*set\s*\}\}/, a.s.t);
          this.querySelector('[data-ipucu]').textContent = metin;
          this.querySelectorAll('[data-sekme]').forEach((t) => {
            const n = +t.dataset.sekme;
            const ad = n === 1 ? this.M.ordun : this.M.rakibin;
            t.textContent = this.secim[n] ? `${ad} · ${this.secim[n].s.t}` : ad;
          });
        }

        /* Seçilen taraf: varyant, fiyat, renk adı ve tonu, gösterilecek görsel.
           Çok renkli sette renk varyanttan, tek varyantlı sette seçilen renkten (sec.c) gelir; boşsa fotoğraftaki renk */
        varyant(sec) {
          if (!sec) return null;
          const v = sec.s.vs.find((x) => x.v === sec.v);
          const r = !v && sec.c ? this.veri.renkler.find((x) => x.ad === sec.c) : null;
          const ek = (v && v.e) || (r && r.e);
          return {
            ek,
            v: sec.v,
            p: v ? v.p : sec.s.p,
            ton: (v && v.ton) || (r && r.ton) || sec.s.ton,
            r: v ? v.r : null,
            ad: (v && (v.r === 'Black' ? 'Siyah' : v.r)) || (r && r.ad) || sec.s.foto,
            gercek: (v && v.ton) || (r && r.ton) || sec.s.fton,
            renk: r ? r.ad : '',
            img: (ek && this.renkUrl(sec.s.rk, ek)) || sec.s.img,
          };
        }

        renkUrl(rk, ek, w) {
          const t = this.veri.renk_sablon;
          if (!rk || !t) return '';
          const url = t.replace('renk-korsanlar-siyah.webp', `renk-${rk}-${ek}.webp`);
          return w ? url.replace('width=900', 'width=' + w) : url;
        }

        /* Renk listesine dokunulunca o setin tüm renklerinin küçük görselleri (400px) indirilir */
        renkleriOnYukle(sec) {
          if (!sec || !sec.s.rk || this.yuklenen?.has(sec.s.k)) return;
          const b = navigator.connection;
          if (b && (b.saveData || /2g/.test(b.effectiveType || ''))) return;
          (this.yuklenen ||= new Set()).add(sec.s.k);
          const ekler = sec.s.vs.length > 1 ? sec.s.vs.map((x) => x.e).filter(Boolean) : this.veri.renkler.map((x) => x.e);
          ekler.forEach((ek) => (new Image().src = this.renkUrl(sec.s.rk, ek, 400)));
        }

        /* Şerit görseli: eski görsel, yenisi yüklenene kadar kalır; önce küçük boy, sonra tam boy */
        seritGorseli(img, url, kucukUrl) {
          if (img.dataset.hedef === url) return;
          img.dataset.hedef = url;
          let tamGeldi = false;
          const koy = (src, tam) => {
            if (img.dataset.hedef !== url || (!tam && tamGeldi)) return;
            if (tam) tamGeldi = true;
            img.src = src;
            img.hidden = false;
          };
          if (kucukUrl) {
            const k = new Image();
            k.onload = () => koy(kucukUrl, false);
            k.src = kucukUrl;
          }
          const t = new Image();
          t.onload = t.onerror = () => koy(url, true);
          t.src = url;
        }

        /* İki tarafın rengi aynı ya da çok yakınsa uyarır; yakınlık RGB uzaklığıyla ölçülür */
        renkUyarisi(a, b) {
          if (!a || !b) return '';
          if (a.ad && a.ad === b.ad) return this.M.ayni_renk;
          const rgb = (h) => (/^#[0-9a-f]{6}$/i.test(h || '') ? [1, 3, 5].map((i) => parseInt(h.slice(i, i + 2), 16)) : null);
          const x = rgb(a.gercek);
          const y = rgb(b.gercek);
          if (!x || !y) return '';
          const rm = (x[0] + y[0]) / 2;
          const d = Math.sqrt((2 + rm / 256) * (x[0] - y[0]) ** 2 + 4 * (x[1] - y[1]) ** 2 + (2 + (255 - rm) / 256) * (x[2] - y[2]) ** 2);
          return d < 110 ? this.M.yakin_renk : '';
        }

        liste() {
          const ul = this.querySelector('[data-liste]');
          const diger = this.secim[this.taraf === 1 ? 2 : 1];
          const secili = this.secim[this.taraf];
          ul.innerHTML = this.veri.setler
            .filter((s) => !this.grup || s.g === this.grup)
            .map((s) => {
              const ayni = secili && secili.s.k === s.k;
              return `<li><button type="button" class="kur__set" data-set="${s.k}" aria-pressed="${ayni}" ${s.a ? '' : 'disabled'}>
                <span style="--ton: ${s.ton}"><img src="${s.kucuk}" alt="" loading="lazy"></span>
                <b>${this.kacis(s.t)}${s.a ? '' : ' · ' + this.kacis(this.M.tukendi)}</b></button></li>`;
            })
            .join('');
          ul.querySelectorAll('[data-set]').forEach((b) =>
            b.addEventListener('click', () => {
              const s = this.veri.setler.find((x) => x.k === b.dataset.set);
              this.secim[this.taraf] = { s, v: s.v };
              this.ciz();
              // İlk taraf seçilince rakip sekmesine geç
              if (this.taraf === 1 && !this.secim[2]) this.sekme(2);
              else this.liste();
              this.oneri();
            })
          );
        }

        /* Seçilen ordunun doğal rakipleri (eşleşmelerden) */
        oneri() {
          const kutu = this.querySelector('[data-oneri]');
          const ana = this.secim[this.taraf === 2 ? 1 : 2];
          if (!ana) return (kutu.hidden = true);
          const rakipler = this.veri.eslesmeler
            .filter((e) => e.includes(ana.s.k))
            .map((e) => (e[0] === ana.s.k ? e[1] : e[0]))
            .map((k) => this.veri.setler.find((s) => s.k === k && s.a))
            .filter(Boolean);
          if (!rakipler.length) return (kutu.hidden = true);
          kutu.hidden = false;
          kutu.innerHTML =
            `<span>${this.kacis(this.M.dogal)}</span>` +
            rakipler.map((s) => `<button type="button" class="hap-dugme" data-oner="${s.k}" aria-pressed="false">${this.kacis(s.t)}</button>`).join('');
          kutu.querySelectorAll('[data-oner]').forEach((b) =>
            b.addEventListener('click', () => {
              const s = this.veri.setler.find((x) => x.k === b.dataset.oner);
              this.secim[this.taraf] = { s, v: s.v };
              this.ciz();
              this.liste();
            })
          );
        }

        ciz() {
          this.ipucu();
          [1, 2].forEach((n) => {
            const sec = this.secim[n];
            const v = this.varyant(sec);
            const serit = this.querySelector(`[data-serit="${n}"]`);
            const img = serit.querySelector('[data-serit-img]');
            serit.toggleAttribute('data-dolu', !!sec);
            serit.style.setProperty('--ton', v ? v.ton : '#ffffff');
            serit.querySelector('[data-serit-bos]').hidden = !!sec;
            const ad = serit.querySelector('[data-serit-ad]');
            ad.hidden = !sec;
            if (sec) {
              this.seritGorseli(img, v.img, v.ek && sec.s.rk ? this.renkUrl(sec.s.rk, v.ek, 400) : '');
              ad.textContent = sec.s.t;
            } else img.hidden = true;
            // Çok renkli set: renk seçimi; fotoğraftaki renkten farklıysa not düşülür
            const kutu = this.querySelector(`[data-renk="${n}"]`);
            const cok = sec && sec.s.vs.length > 1;
            kutu.hidden = !(cok || (sec && sec.s.rk));
            if (!kutu.hidden) {
              const sel = kutu.querySelector('select');
              kutu.querySelector('[data-renk-etiket]').textContent = `${sec.s.t} ${this.M.renk}`;
              sel.innerHTML = cok
                ? sec.s.vs
                    .map((x) => `<option value="${x.v}" ${x.a ? '' : 'disabled'} ${x.v === sec.v ? 'selected' : ''}>${this.kacis(x.r)}</option>`)
                    .join('')
                : `<option value="">${this.kacis(this.M.foto_secenek)}</option>` +
                  this.veri.renkler.map((x) => `<option value="${this.kacis(x.ad)}" ${x.ad === sec.c ? 'selected' : ''}>${this.kacis(x.ad)}</option>`).join('');
            }
          });
          const a = this.varyant(this.secim[1]);
          const b = this.varyant(this.secim[2]);
          const fiyat = this.querySelector('[data-fiyat]');
          const ekle = this.querySelector('[data-ekle]');
          if (a && b) {
            const toplam = a.p + b.p;
            const indirimli = Math.max(0, toplam - this.indirim);
            const farkli = [a, b].some((v) => v.renk || v.r);
            fiyat.innerHTML =
              `${this.kacis(this.M.fiyat)} ${this.para(indirimli)}` +
              (this.indirim ? ` <s>${this.para(toplam)}</s>` : '') +
              (farkli ? `<small>${this.kacis(this.M.foto_renk)}</small>` : '');
            ekle.disabled = false;
            ekle.dataset.ciftEkle = `${a.v},${b.v}`;
            ekle.dataset.renkler = `${a.renk}|${b.renk}`;
            ekle.dataset.setAd = `${this.secim[1].s.t} × ${this.secim[2].s.t}`;
            const url = new URL(location.href);
            url.searchParams.set('a', this.secim[1].s.k);
            url.searchParams.set('b', this.secim[2].s.k);
            history.replaceState(null, '', url);
          } else {
            fiyat.textContent = this.M.iki_sec;
            ekle.disabled = true;
          }
          const uyari = this.querySelector('[data-uyari]');
          uyari.textContent = this.renkUyarisi(a, b);
          uyari.hidden = !uyari.textContent;
          this.gorDugme();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ukd-hesaplama"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ukd-hesap')) {
    /* TSF Tablo 2: puan farkı (üst sınır) → üstün oyuncunun beklenen skoru. Fark en çok 350 sayılır. */
    const TABLO_2 = [
      [3, 0.5], [10, 0.51], [17, 0.52], [25, 0.53], [32, 0.54], [39, 0.55], [46, 0.56], [53, 0.57], [61, 0.58],
      [68, 0.59], [76, 0.6], [83, 0.61], [91, 0.62], [98, 0.63], [106, 0.64], [113, 0.65], [121, 0.66], [129, 0.67],
      [137, 0.68], [145, 0.69], [153, 0.7], [162, 0.71], [170, 0.72], [179, 0.73], [188, 0.74], [197, 0.75],
      [206, 0.76], [215, 0.77], [225, 0.78], [235, 0.79], [245, 0.8], [256, 0.81], [267, 0.82], [278, 0.83],
      [290, 0.84], [302, 0.85], [315, 0.86], [328, 0.87], [344, 0.88], [357, 0.89],
    ];
    /* TSF Tablo 1: skor yüzdesi 0,50 → 1,00 için performans farkı (dp); 0,50 altı simetrik eksi */
    const TABLO_1 = [
      0, 7, 14, 21, 29, 36, 43, 50, 57, 65, 72, 80, 87, 95, 102, 110, 117, 125, 133, 141, 149, 158, 166, 175, 184,
      193, 202, 211, 220, 230, 240, 248, 256, 264, 272, 280, 288, 296, 304, 312, 320, 328, 334, 342, 350, 358, 366,
      374, 382, 400, 400,
    ];
    const FARK_SINIRI = 350;
    const TABAN = 1000;

    const katsayi = (ukd) => (ukd >= 2400 ? 10 : ukd >= 2000 ? 15 : ukd >= 1600 ? 20 : ukd >= 1300 ? 25 : 30);
    const ustunBeklenen = (fark) => {
      const d = Math.min(Math.abs(fark), FARK_SINIRI);
      return (TABLO_2.find(([ust]) => d <= ust) || TABLO_2[TABLO_2.length - 1])[1];
    };
    const beklenen = (ben, rakip) => (ben >= rakip ? ustunBeklenen(ben - rakip) : 1 - ustunBeklenen(ben - rakip));
    const dp = (oran) => {
      const yuzde = Math.round(oran * 100);
      return yuzde >= 50 ? TABLO_1[yuzde - 50] : -TABLO_1[50 - yuzde];
    };
    const sayi = (n, basamak = 2) =>
      n.toLocaleString('tr-TR', { minimumFractionDigits: 0, maximumFractionDigits: basamak, useGrouping: false });
    const kacis = (s) => s.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
    const isaretli = (n) => (n > 0 ? '+' : n < 0 ? '−' : '') + sayi(Math.abs(n));

    customElements.define(
      'ukd-hesap',
      class extends HTMLElement {
        connectedCallback() {
          /* Shopify çeviri metnindeki ' ve " işaretlerini &#39; ve &quot; olarak verir; metin JS ile yazılınca kod görünmesin diye çözülür */
          const cozucu = document.createElement('textarea');
          const coz = (d) =>
            typeof d === 'string'
              ? ((cozucu.innerHTML = d), cozucu.value)
              : Array.isArray(d)
                ? d.map(coz)
                : d && typeof d === 'object'
                  ? Object.fromEntries(Object.entries(d).map(([k, v]) => [k, coz(v)]))
                  : d;
          this.M = coz(JSON.parse(this.querySelector('[data-metin]').textContent));
          this.ben = this.querySelector('[data-ben]');
          this.liste = this.querySelector('[data-liste]');
          this.sablon = this.querySelector('[data-sablon]');
          this.querySelector('[data-mac-ekle]').addEventListener('click', () => {
            this.satirEkle().querySelector('[data-rakip]').focus();
          });
          const getir = this.querySelector('[data-getir]');
          if (getir) {
            const alan = getir.querySelector('[data-cr]');
            this.servis = getir.dataset.getir;
            getir.querySelector('[data-sonuc-gor]').addEventListener('click', () => this.sonucaGit());
            getir.querySelector('[data-cr-getir]').addEventListener('click', () => this.bul(alan.value));
            alan.addEventListener('keydown', (e) => e.key === 'Enter' && (e.preventDefault(), this.bul(alan.value)));
          }
          for (let i = 0; i < 5; i++) this.satirEkle();
          this.addEventListener('input', () => this.hesapla());
          this.addEventListener('change', () => this.hesapla());
          this.hesapla();
        }

        satirEkle() {
          const li = this.sablon.content.firstElementChild.cloneNode(true);
          li.querySelectorAll('[data-skor]').forEach((b) =>
            b.addEventListener('click', () => {
              const secili = b.getAttribute('aria-pressed') === 'true';
              li.querySelectorAll('[data-skor]').forEach((x) => x.setAttribute('aria-pressed', 'false'));
              b.setAttribute('aria-pressed', secili ? 'false' : 'true');
              this.hesapla();
            })
          );
          li.querySelector('[data-ukdsiz]').addEventListener('change', (e) => {
            li.querySelector('[data-rakip]').disabled = e.target.checked;
          });
          li.querySelector('[data-sil]').addEventListener('click', () => {
            li.remove();
            this.numarala();
            this.hesapla();
          });
          this.liste.append(li);
          this.numarala();
          return li;
        }

        /* chess-results oyuncu kartını Worker üzerinden okur; mevcut UKD'yi ve maçları forma yazar.
           Hükmen maçlar UKD'ye girmediği için eklenmez, sayısı bildirilir. */
        async getir(adres) {
          const durum = this.querySelector('[data-cr-durum]');
          const dugme = this.querySelector('[data-cr-getir]');
          if (!adres.trim()) return;
          dugme.disabled = true;
          durum.textContent = this.M.cr_yukleniyor;
          try {
            const yanit = await fetch(`${this.servis}?url=${encodeURIComponent(adres.trim())}`);
            const veri = await yanit.json();
            if (!yanit.ok) throw new Error(veri.hata);
            const sayilan = veri.maclar.filter((m) => !m.hukmen);
            const hukmen = veri.maclar.length - sayilan.length;
            if (veri.oyuncu.ukd) this.ben.value = veri.oyuncu.ukd;
            this.liste.replaceChildren();
            sayilan.forEach((m) => {
              const li = this.satirEkle();
              if (m.rakip) {
                const ad = li.querySelector('[data-ad]');
                // chess-results "Soyad, Ad" yazar; "Ad Soyad" olarak gösterilir
                ad.textContent = ad.title = m.rakip.includes(', ') ? m.rakip.split(', ').reverse().join(' ') : m.rakip;
                ad.hidden = false;
                li.classList.add('ukd__mac--adli');
              }
              // Yabancı rakibin UKD'si yok: satır boş kalır, hesaba girmez; kullanıcı isterse doldurur
              if (m.ukd) li.querySelector('[data-rakip]').value = m.ukd;
              else if (!m.yabanci) {
                li.querySelector('[data-ukdsiz]').checked = true;
                li.querySelector('[data-rakip]').disabled = true;
              }
              li.querySelector(`[data-skor="${m.sonuc}"]`)?.setAttribute('aria-pressed', 'true');
            });
            if (!sayilan.length) this.satirEkle();
            const parcalar = [sayilan.length ? this.M.cr_tamam.replace('{turnuva}', veri.turnuva).replace('{n}', sayilan.length) : this.M.cr_bos];
            if (hukmen) parcalar.push(this.M.cr_hukmen.replace('{n}', hukmen));
            const yabanci = sayilan.filter((m) => m.yabanci).length;
            if (yabanci) parcalar.push(this.M.cr_yabanci.replace('{n}', yabanci));
            if (!veri.oyuncu.ukd) parcalar.push(this.M.cr_ukd_yok);
            durum.textContent = parcalar.join(' ');
            this.hesapla();
            this.querySelector('[data-sonuc-gor]').hidden = false;
          } catch (e) {
            durum.textContent = this.M.cr_hata;
            this.querySelector('[data-sonuc-gor]').hidden = true;
          } finally {
            dugme.disabled = false;
          }
        }

        /* Alan bağlantı içeriyorsa kartı getirir; yoksa isimle arar, turnuvaları listeler.
           Tek oyuncu bulunursa en yeni turnuvanın maçları kendiliğinden gelir. */
        async bul(metin) {
          metin = metin.trim();
          if (!metin) return;
          const liste = this.querySelector('[data-cr-liste]');
          if (/chess-results\.com/i.test(metin)) {
            liste.hidden = true;
            return this.getir(metin);
          }
          const durum = this.querySelector('[data-cr-durum]');
          const dugme = this.querySelector('[data-cr-getir]');
          dugme.disabled = true;
          this.querySelector('[data-sonuc-gor]').hidden = true;
          durum.textContent = this.M.cr_araniyor;
          let tek = false;
          try {
            const yanit = await fetch(`${this.servis}?ara=${encodeURIComponent(metin)}`);
            const veri = await yanit.json();
            if (!yanit.ok) throw new Error(veri.hata);
            const oyuncular = veri.oyuncular.filter((o) => o.turnuvalar.length);
            liste.replaceChildren();
            liste.hidden = !oyuncular.length;
            if (!oyuncular.length) {
              durum.textContent = this.M.cr_bulunamadi;
              return;
            }
            const tarih = (t) => (t || '').split('/').reverse().join('.');
            oyuncular.forEach((o) => {
              const grup = document.createElement('div');
              grup.className = 'ukd__oyuncu';
              const bas = document.createElement('p');
              bas.className = 'ukd__oyuncu-ad';
              bas.textContent = [o.ad, o.kulup].filter(Boolean).join(' · ');
              const ul = document.createElement('ul');
              ul.setAttribute('role', 'list');
              o.turnuvalar.forEach((tu) => {
                const b = document.createElement('button');
                b.type = 'button';
                b.className = 'ukd__turnuva';
                b.setAttribute('aria-pressed', 'false');
                b.dataset.kart = tu.kart;
                const ad = document.createElement('b');
                // chess-results aramada turnuva adını 30 harfte keser
                ad.textContent = tu.ad.length >= 30 ? tu.ad + '…' : tu.ad;
                const alt = document.createElement('span');
                alt.textContent = [tarih(tu.bitis), tu.tur ? this.M.cr_tur.replace('{n}', tu.tur) : ''].filter(Boolean).join(' · ');
                b.append(ad, alt);
                b.addEventListener('click', () => {
                  liste.querySelectorAll('[data-kart]').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
                  this.getir(tu.kart);
                });
                const li = document.createElement('li');
                li.append(b);
                ul.append(li);
              });
              grup.append(bas, ul);
              liste.append(grup);
            });
            tek = oyuncular.length === 1;
            if (!tek) durum.textContent = this.M.cr_coklu.replace('{n}', oyuncular.length);
          } catch (e) {
            durum.textContent = this.M.cr_hata;
          } finally {
            dugme.disabled = false;
          }
          if (tek) liste.querySelector('[data-kart]').click();
        }

        /* "Sonucu gör" düğmesi: sonuç alanına kaydırır (masaüstünde düğme gizli, sonuç yanda durur) */
        sonucaGit() {
          const sonuc = this.querySelector('[data-sonuc]');
          const sakin = matchMedia('(prefers-reduced-motion: reduce)').matches;
          sonuc.scrollIntoView({ behavior: sakin ? 'auto' : 'smooth', block: 'start' });
        }

        numarala() {
          this.liste.querySelectorAll('[data-tur]').forEach((t, i) => (t.textContent = i + 1));
        }

        hesapla() {
          const ben = parseFloat(this.ben.value);
          const kAlani = this.querySelector('[data-k]');
          const gecerli = Number.isFinite(ben) && ben >= TABAN && ben <= 3000;
          kAlani.textContent = gecerli ? this.M.k.replace('{k}', katsayi(ben)) : this.M.k_bos;

          const maclar = [];
          this.liste.querySelectorAll('.ukd__mac').forEach((li, i) => {
            const secim = li.querySelector('[data-skor][aria-pressed="true"]');
            if (!secim) return;
            const ukdsiz = li.querySelector('[data-ukdsiz]').checked;
            const rakip = parseFloat(li.querySelector('[data-rakip]').value);
            if (!ukdsiz && !(Number.isFinite(rakip) && rakip >= TABAN && rakip <= 3000)) return;
            const ad = li.querySelector('[data-ad]').textContent;
            maclar.push({ tur: i + 1, ad, ukdsiz, rakip, skor: parseFloat(secim.dataset.skor) });
          });

          const dolu = this.querySelector('[data-dolu]');
          const bos = this.querySelector('[data-bos]');
          if (!gecerli || !maclar.length) {
            dolu.hidden = true;
            bos.hidden = false;
            return;
          }
          dolu.hidden = false;
          bos.hidden = true;

          const k = katsayi(ben);
          let toplam = 0;
          let puan = 0;
          let ukdliPuan = 0;
          const ukdliRakipler = [];
          const satirlar = maclar.map((m) => {
            puan += m.skor;
            let we = null;
            let degisim;
            if (m.ukdsiz) {
              /* UKD'siz rakip: galibiyette +0,1k, yenilgide −0,1k, beraberlikte değişim yok */
              degisim = m.skor === 1 ? k * 0.1 : m.skor === 0 ? -k * 0.1 : 0;
            } else {
              we = beklenen(ben, m.rakip);
              degisim = k * (m.skor - we);
              ukdliPuan += m.skor;
              /* Performansta rakip ortalaması 350 puan sınırıyla alınır */
              ukdliRakipler.push(Math.min(Math.max(m.rakip, ben - FARK_SINIRI), ben + FARK_SINIRI));
            }
            toplam += degisim;
            const skor = this.M.skor[m.skor === 1 ? 2 : m.skor === 0.5 ? 1 : 0];
            const sinif = degisim > 0 ? 'ukd__arti' : degisim < 0 ? 'ukd__eksi' : '';
            return `<tr><td>${m.tur}</td><td${m.ad ? ' class="ukd__tablo-rakip"' : ''}>${
              m.ad ? `<span class="ukd__tablo-ad">${kacis(m.ad)}</span><span class="ukd__tablo-ukd">` : ''
            }${m.ukdsiz ? this.M.ukdsiz : m.rakip}${m.ad ? '</span>' : ''}</td><td>${skor}</td><td>${
              we === null ? '–' : sayi(we)
            }</td><td class="${sinif}">${isaretli(degisim)}</td></tr>`;
          });
          this.querySelector('[data-satirlar]').innerHTML = satirlar.join('');

          const ham = ben + toplam;
          const yeni = Math.max(TABAN, ham);
          const degisimAlani = this.querySelector('[data-degisim]');
          degisimAlani.textContent = isaretli(toplam);
          degisimAlani.className = toplam > 0 ? 'ukd__arti' : toplam < 0 ? 'ukd__eksi' : '';
          this.querySelector('[data-yeni]').innerHTML =
            sayi(yeni) + (ham < TABAN ? `<small>${this.M.taban}</small>` : '');
          this.querySelector('[data-puan]').textContent = `${sayi(puan, 1)} / ${maclar.length}`;

          const perf = this.querySelector('[data-performans]');
          if (ukdliRakipler.length) {
            const ro = ukdliRakipler.reduce((a, b) => a + b, 0) / ukdliRakipler.length;
            perf.textContent = sayi(Math.round(ro + dp(ukdliPuan / ukdliRakipler.length)), 0);
          } else {
            perf.textContent = this.M.perf_yok;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vitrin"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-vitrin]').forEach((vitrin) => {
    const slaytlar = [...vitrin.querySelectorAll('[data-slayt]')];
    const cubuklar = [...vitrin.querySelectorAll('[data-git]')];
    if (slaytlar.length < 2) return;
    const sure = 4500;
    vitrin.style.setProperty('--sure', sure + 'ms');
    let simdiki = 0;
    let zaman;
    // Hareket azaltma açıksa ya da ziyaretçi elle gezinmişse vitrin kendiliğinden dönmez
    let durdu = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // Bölüm görünmüyorken dönmez; çubuk animasyonu ekrana gelince başlar
    let gorunur = false;

    const goster = (i) => {
      simdiki = (i + slaytlar.length) % slaytlar.length;
      slaytlar.forEach((s, j) => (s.hidden = j !== simdiki));
      cubuklar.forEach((c, j) => {
        c.setAttribute('aria-pressed', 'false');
        // Çubuk animasyonu baştan başlasın diye bir kare sonra; arka arkaya tıklamada yalnız son slayt dolar
        if (j === simdiki) requestAnimationFrame(() => j === simdiki && c.setAttribute('aria-pressed', 'true'));
      });
    };
    const baslat = () => {
      clearInterval(zaman);
      if (!durdu && gorunur) {
        goster(simdiki);
        zaman = setInterval(() => goster(simdiki + 1), sure);
      }
    };
    const elle = (i) => {
      durdu = true;
      vitrin.classList.add('duraklat');
      clearInterval(zaman);
      goster(i);
    };

    cubuklar.forEach((c, j) => c.addEventListener('click', () => elle(j)));
    vitrin.querySelector('[data-onceki]')?.addEventListener('click', () => elle(simdiki - 1));
    vitrin.querySelector('[data-sonraki]')?.addEventListener('click', () => elle(simdiki + 1));

    /* Telefonda parmakla sağa sola kaydırma */
    const sahne = vitrin.querySelector('.vitrin__sahne');
    let basX = null;
    let basY = 0;
    sahne.addEventListener('touchstart', (e) => {
      basX = e.touches[0].clientX;
      basY = e.touches[0].clientY;
    }, { passive: true });
    sahne.addEventListener('touchend', (e) => {
      if (basX === null) return;
      const dx = e.changedTouches[0].clientX - basX;
      const dy = e.changedTouches[0].clientY - basY;
      basX = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) elle(simdiki + (dx < 0 ? 1 : -1));
    });

    vitrin.addEventListener('mouseenter', () => clearInterval(zaman));
    vitrin.addEventListener('mouseleave', baslat);
    vitrin.addEventListener('focusin', () => clearInterval(zaman));
    vitrin.addEventListener('focusout', baslat);
    if (durdu) vitrin.classList.add('duraklat');

    new IntersectionObserver(([g]) => {
      gorunur = g.isIntersecting;
      if (gorunur) baslat();
      else clearInterval(zaman);
    }, { threshold: 0.3 }).observe(vitrin);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yapiskan-sepet"]) return;
  try {
    
  if (!customElements.get('yapiskan-sepet')) {
    customElements.define(
      'yapiskan-sepet',
      class extends HTMLElement {
        connectedCallback() {
          this.ana = document.querySelector('[data-ekle]');
          if (!this.ana) return;
          this.dugme = this.querySelector('[data-yapiskan-dugme]');
          this.dugme.addEventListener('click', () => this.ana.click());

          const esle = () => {
            this.dugme.textContent = this.ana.textContent.replace(/\s+/g, ' ').trim();
            this.dugme.disabled = this.ana.disabled;
          };
          esle();
          new MutationObserver(esle).observe(this.ana, { childList: true, subtree: true, characterData: true, attributes: true });

          /* Ana düğme ekrandayken gizlenir; sayfa açılışında düğme aşağıda kaldığı için fiyat ilk ekranda görünür.
             Gizliyken klavye ve ekran okuyucu çubuğa ulaşmaz (inert). */
          let bekliyor = false;
          const bak = () => {
            bekliyor = false;
            const r = this.ana.getBoundingClientRect();
            const gorunur = !(r.bottom > 0 && r.top < innerHeight);
            this.toggleAttribute('data-gorunur', gorunur);
            this.inert = !gorunur;
            this.ajaniKaydir();
          };
          const sirala = () => {
            if (!bekliyor) {
              bekliyor = true;
              requestAnimationFrame(bak);
            }
          };
          addEventListener('scroll', sirala, { passive: true });
          addEventListener('resize', sirala);
          /* Clarity ajanı sayfaya sonradan eklenir; eklendiği an çubuğun durumuna göre yerleşsin */
          new MutationObserver(() => this.ajaniKaydir()).observe(document.body, { childList: true });
          bak();
        }

        /* Clarity'nin AI düğmesi (ads-agent-host, açık shadow DOM) sağ altta durur ve çubuğun üstüne biner.
           Çubuk görünürken düğme çubuğun yüksekliği kadar yukarı kayar. `translate` ajanın kendi
           animasyon transform'una dokunmaz; ajanın sınıf adları değişirse kural yalnızca etkisiz kalır. */
        ajaniKaydir() {
          const ajan = document.getElementById('ads-agent-host');
          const kok = ajan?.shadowRoot;
          if (!kok) return;
          if (!kok.querySelector('style[data-yapiskan-ayar]')) {
            const stil = document.createElement('style');
            stil.dataset.yapiskanAyar = '';
            stil.textContent =
              '.fixed.cursor-pointer{transition:translate .28s cubic-bezier(.2,.8,.2,1)}' +
              ':host([data-yapiskan]) .fixed.cursor-pointer{translate:0 calc(-1 * var(--yapiskan-yukseklik, 72px))}';
            kok.append(stil);
          }
          const gorunur = this.hasAttribute('data-gorunur');
          ajan.style.setProperty('--yapiskan-yukseklik', this.offsetHeight + 'px');
          ajan.toggleAttribute('data-yapiskan', gorunur);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
